import React, { useState, useEffect, useContext } from "react";
import {
  Card,
  Page,
  Layout,
  Banner,
  Loading,
  FooterHelp,
  Link,
} from "@shopify/polaris";
import { useTranslation } from "react-i18next";
import FeatureItem from "./FeatureItem";
import PrimaryPlanCard from "./PrimaryPlanCard";
import SecondaryPlanCard from "./SecondaryPlanCard";
import { TitleBar } from "@shopify/app-bridge-react";
import { useNavigate } from "@shopify/app-bridge-react";
import { useEditPlan, useUpdatePlan } from "../../../../hooks/queries/plans";

export default function PlanEdit(props) {
  const { t } = useTranslation();
  const [planDetails, setPlanDetails] = useState(null);

  const navigate = useNavigate();

  const { data } = useEditPlan();
  useEffect(() => setPlanDetails(data), [data]);

  const updatePlanMutation = useUpdatePlan({
    onSuccess: (data) => {
      navigate(data.confirmation_url);
    },
  });

  function activatePlan(type) {
    updatePlanMutation.mutate(type);
  }

  if (!planDetails) return null;
  const { announcement } = planDetails;
  return (
    <>
      <Page>
        <TitleBar
          title={t("settings.plan.edit.title")}
          breadcrumbs={[{ content: t("settings.plan.title"), url: "/plan" }]}
        />
        <Layout>
          {announcement && (
            <Layout.Section fullWidth>
              <Banner title={announcement.title} status={announcement.status}>
                <p dangerouslySetInnerHTML={{ __html: announcement.text }}></p>
              </Banner>
            </Layout.Section>
          )}

          {planDetails.primary_plans.map((plan) => (
            <Layout.Section oneThird>
              <PrimaryPlanCard
                plan={plan}
                loading={updatePlanMutation.isLoading}
                activatePlan={activatePlan}
              />
            </Layout.Section>
          ))}

          <Layout.Section fullWidth>
            <Card>
              <Card.Section title={t("settings.plan.edit.allPlansInclude")}>
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr 1fr",
                    gridGap: "1.6rem 4rem",
                    padding: "1rem 0",
                  }}
                >
                  <FeatureItem
                    title={t("settings.plan.edit.allFeatures.seoDirectory.title")}
                    description={t("settings.plan.edit.allFeatures.seoDirectory.description")}
                  />
                  <FeatureItem
                    title={t("settings.plan.edit.allFeatures.mapPage.title")}
                    description={t("settings.plan.edit.allFeatures.mapPage.description")}
                  />
                  <FeatureItem
                    title={t("settings.plan.edit.allFeatures.tags.title")}
                    description={t("settings.plan.edit.allFeatures.tags.description")}
                  />
                  <FeatureItem
                    title={t("settings.plan.edit.allFeatures.openingHours.title")}
                    description={t("settings.plan.edit.allFeatures.openingHours.description")}
                  />
                  <FeatureItem
                    title={t("settings.plan.edit.allFeatures.mapStyles.title")}
                    description={t("settings.plan.edit.allFeatures.mapStyles.description")}
                  />
                  <FeatureItem
                    title={t("settings.plan.edit.allFeatures.customFields.title")}
                    description={t("settings.plan.edit.allFeatures.customFields.description")}
                  />
                  <FeatureItem
                    title={t("settings.plan.edit.allFeatures.csvUpload.title")}
                    description={t("settings.plan.edit.allFeatures.csvUpload.description")}
                  />
                  <FeatureItem
                    title={t("settings.plan.edit.allFeatures.richSnippets.title")}
                    description={t("settings.plan.edit.allFeatures.richSnippets.description")}
                  />
                  <FeatureItem
                    title={t("settings.plan.edit.allFeatures.directionsAndCalls.title")}
                    description={t("settings.plan.edit.allFeatures.directionsAndCalls.description")}
                  />
                  <FeatureItem
                    title={t("settings.plan.edit.allFeatures.languageSupport.title")}
                    description={t("settings.plan.edit.allFeatures.languageSupport.description")}
                  />
                </div>
              </Card.Section>
            </Card>
          </Layout.Section>
        </Layout>
      </Page>
      <Page title={t("settings.plan.edit.needingMoreLocations")}>
        <Layout>
          {planDetails.extra_plans.map((plan) => (
            <Layout.Section fullWidth>
              <SecondaryPlanCard
                plan={plan}
                loading={updatePlanMutation.isLoading}
                activatePlan={activatePlan}
              />
            </Layout.Section>
          ))}
        </Layout>
        <FooterHelp>
          {t("settings.plan.edit.footerQuestion")}{" "}
          <Link
            onClick={() => {
              window.Beacon("navigate", "/ask/");
              window.Beacon("open");
            }}
          >
            {t("settings.plan.edit.sendMessage")}
          </Link>
        </FooterHelp>
      </Page>
    </>
  );
}
